import * as React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Input } from "@jhool-io/fe-components";

const schema = yup.object({
    code: yup
        .string()
        .required("Verification code is required")
        .min(4, "Code must be at least 4 characters")
        .max(4, "Code must be at most 4 characters"),
});

interface PaymentLinkCodeVerificationProps {
    onFormSubmit: (code: string) => void;
    isLoading?: boolean;
}

export default function PaymentLinkCodeVerification({
    onFormSubmit,
    isLoading = false,
}: PaymentLinkCodeVerificationProps) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<{ code: string }>({
        resolver: yupResolver(schema),
        mode: "onChange",
    });

    const onSubmit = (formData: { code: string }) => {
        onFormSubmit(formData.code);
    };

    return (
        <>
            <div className="text-center mb-9">
                <p className="text-sm text-gray">
                    This payment link requires a verification code to continue
                </p>
            </div>
            <form
                id="payment-link-code-verification"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="fg">
                    <Input
                        {...register("code")}
                        label="Verification Code"
                        placeholder="Enter code"
                        hasError={!!errors.code}
                        errorText={errors.code?.message}
                        autoFocus
                        disabled={isLoading}
                    />
                </div>
            </form>
        </>
    );
}
